import { useEffect } from 'react';

export default function HomeSEO() {
  useEffect(() => {
    const jsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          name: '蜜桃视频',
          url: 'https://www.mitaovideo.com',
          logo: 'https://www.mitaovideo.com/logo.png',
          description: '蜜桃视频是专注优质短视频内容的创作与分享平台，汇聚海量精彩视频资源，涵盖生活、美食、娱乐、创意等多元内容。',
          email: 'support@mitaovideo.com',
          telephone: '400-888-9999',
          address: {
            '@type': 'PostalAddress',
            addressLocality: '北京',
            addressRegion: '海淀区',
            streetAddress: '中关村科技园区创新路88号蜜桃大厦',
            addressCountry: 'CN',
          },
          sameAs: [
            'https://weibo.com/mitaovideo',
            'https://space.bilibili.com/mitaovideo',
          ],
        },
        {
          '@type': 'WebSite',
          name: '蜜桃视频',
          url: 'https://www.mitaovideo.com',
          description: '精选短视频内容平台，发现精彩，记录生活。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://www.mitaovideo.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        },
        {
          '@type': 'WebPage',
          name: '蜜桃视频 - 精选短视频内容平台',
          url: 'https://www.mitaovideo.com',
          description: '蜜桃视频是专注优质短视频内容的创作与分享平台，汇聚海量精彩视频资源。',
          isPartOf: { '@type': 'WebSite', name: '蜜桃视频', url: 'https://www.mitaovideo.com' },
          about: { '@type': 'Organization', name: '蜜桃视频' },
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: '蜜桃视频是什么？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '蜜桃视频是一个精选短视频内容平台，汇聚海量优质视频资源，涵盖生活、美食、娱乐、创意等多元内容领域。我们致力于为内容创作者和视频爱好者打造优质的创作与观赏体验。',
              },
            },
            {
              '@type': 'Question',
              name: '如何在蜜桃视频上发布自己的作品？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '注册成为蜜桃视频创作者后，点击右上角的创作中心按钮，即可上传您的短视频作品。我们支持多种视频格式，并提供丰富的编辑工具帮助您打造优质内容。',
              },
            },
            {
              '@type': 'Question',
              name: '蜜桃视频的内容审核标准是什么？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '我们坚持优质、健康、创新的内容理念。所有上传内容需符合国家法律法规和社区规范。审核团队会在24小时内完成内容审核。',
              },
            },
            {
              '@type': 'Question',
              name: '蜜桃视频如何保障创作者收益？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '我们建立了完善的创作者激励机制，包括流量分成、品牌合作、打赏功能和创作基金等多种方式。优质创作者还可获得平台流量扶持和专属运营服务。',
              },
            },
          ],
        },
      ],
    };

    const scriptEl = document.createElement('script');
    scriptEl.type = 'application/ld+json';
    scriptEl.setAttribute('data-schema', 'home-page');
    scriptEl.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(scriptEl);

    return () => {
      if (scriptEl.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }
    };
  }, []);

  return null;
}